import { createFileRoute } from '@tanstack/react-router';

import { getConnectedAppQueryOptions } from '@/_pages/connected-apps/api-service';
import Loading from '@/_pages/connected-apps/profile/loading';

export const Route = createFileRoute('/_private/connected-apps/$id')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getConnectedAppQueryOptions(opts.params.id)),
  pendingComponent: Loading,
});
